import { Button } from "../Button/Button";
import React, { useEffect, useState } from "react";
import "./LoginPage.css";
import { Messages } from "./Messages";
/**
 * Component displaying a Login Subscription Picker.
 */
export function SubscriptionPicker(props) {
    const { appName, subscriptions, styles, onSelectSubscription } = props;
    const subscriptionPickerName = appName + " Subscription Picker";
    const subscriptionPickerId = props.id ?? subscriptionPickerName.replaceAll(" ", "-");
    const [selectedSubscription, setSelectedSubscription] = useState(props.selectedSubscription ?? "");
    const loginTitle = Messages.LOGIN_TITLE.getMessage();
    const subscriptionInstructions = Messages.SUBSCRIPTION_INSTRUCTIONS.getMessage();
    useEffect(() => {
        if (selectedSubscription && selectedSubscription.length > 0) {
            onSelectSubscription(selectedSubscription);
        }
    }, [selectedSubscription, onSelectSubscription]);
    const handleSelectSubscription = (event, subscription) => {
        setSelectedSubscription(subscription ?? "");
    };
    const defaultStyles = {
        container: {},
        loginHeader: {},
        loginTitle: {},
        loginInstructions: {},
        loginBody: {},
        list: {},
        listItemButton: {}
    };
    const combinedStyles = styles ? { ...defaultStyles, ...styles } : defaultStyles;
    return (React.createElement("div", { id: subscriptionPickerId, "aria-label": subscriptionPickerName, className: "aderant-login-subscription-picker", style: combinedStyles.container },
        React.createElement("div", { className: "aderant-login-header", style: combinedStyles.loginHeader },
            React.createElement("h1", { style: combinedStyles.loginTitle }, loginTitle),
            React.createElement("p", { style: combinedStyles.loginInstructions }, subscriptionInstructions)),
        React.createElement("div", { className: "aderant-login-body", style: combinedStyles.loginBody },
            React.createElement("div", { className: "aderant-login-subscription-list", "aria-label": "Subscription List", style: combinedStyles.list ?? {} }, subscriptions.map((subscription) => (React.createElement(Button, { key: subscription, className: "aderant-login-subscription-list-item", variant: "contained", size: "medium", style: combinedStyles.listItemButton, rounded: true, onClick: (event) => handleSelectSubscription(event, subscription), text: subscription })))))));
}
